import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { DotLottieReact } from '@lottiefiles/dotlottie-react';
import styles from './LessonContentRenderer.module.css';

interface SignContractProps {
    title: string;
    content: string;
}

const SignContract: React.FC<SignContractProps> = ({ title, content }) => {
    const [isSigned, setIsSigned] = useState(false);
    const [showCelebration, setShowCelebration] = useState(false);

    const handleSign = () => {
        setIsSigned(true);
        setShowCelebration(true);
        // Reset celebration after a few seconds
        setTimeout(() => setShowCelebration(false), 3000);
    };

    return (
        <motion.div
            className={styles.contractContainer}
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
        >
            <div className={styles.contractHeader}>
                <span className={styles.contractIcon}>📜</span>
                <h3>{title}</h3>
            </div>

            <div className={styles.contractBody}>
                <p dangerouslySetInnerHTML={{ __html: content }} />
            </div>

            <div className={styles.contractFooter}>
                <button
                    onClick={handleSign}
                    disabled={isSigned}
                    className={`${styles.signButton} ${isSigned ? styles.signed : ''}`}
                >
                    {isSigned ? (
                        <>
                            <span className={styles.signedCheck}>✓</span>
                            Signed & Committed
                        </>
                    ) : (
                        "I Accept the Social Contract"
                    )}
                </button>

                {isSigned && (
                    <motion.div
                        initial={{ opacity: 0, scale: 0.5 }}
                        animate={{ opacity: 1, scale: 1 }}
                        className={styles.signatureDisplay}
                    >
                        <DotLottieReact
                            src="/assets/animations/contract-sign.lottie"
                            autoplay
                            loop={false}
                            className={styles.contractLottie}
                        />
                    </motion.div>
                )}
            </div>

            <AnimatePresence>
                {showCelebration && (
                    <motion.div
                        initial={{ opacity: 0, scale: 0.8 }}
                        animate={{ opacity: 1, scale: 1 }}
                        exit={{ opacity: 0 }}
                        className={styles.contractCelebration}
                    >
                        <DotLottieReact
                            src="/assets/animations/confetti-party.lottie"
                            autoplay
                            loop={false}
                            style={{ width: '200px', height: '200px' }}
                        />
                    </motion.div>
                )}
            </AnimatePresence>
        </motion.div>
    );
};

export default SignContract;
